// extracted by mini-css-extract-plugin
export var header = "_go-0";